module.exports = {
    URL: 'https://api.ecomtechbd.com/',
    WS_URL: 'wss://socket.ecomtechbd.com/notifications',
};
// module.exports = {
//     URL: 'http://localhost:4002/',
//     WS_URL: 'ws://localhost:9001/notifications',
// };
